// src/features/events/eventsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { selectFilters } from "../filters/filterSlice";
import {
  showLoadingScreen,
  setSnackBar,
} from "../../reusable_components/site_data/siteDataSlice";
import { convert_to_request_parameters } from "../../reusable_components/utilityfunctions";
import { backend_url } from "../../App";

export const eventsSlice = createSlice({
  name: "events",
  initialState: {
    events: {
      count: 0,
      results: [],
    },
  },
  reducers: {
    setEvents: (state, action) => {
      state.events.count = action.payload.count;
      state.events.results = action.payload.results;
    },
    resetEvents: (state) => {
      state.events = { count: 0, results: [] };
    },
  },
});

const Header = {};
export const getEvents =
  (page, filterApplied, status = null, rowsPerPage = 10) =>
  (dispatch, getState) => {
    dispatch(showLoadingScreen(true));
    Header["Authorization"] = `Token ${localStorage.getItem("token")}`;
    let config = { headers: Header };

    const filters = selectFilters(getState());
    let result = convert_to_request_parameters(
      filters.range,
      filters.startTime,
      filters.endTime,
    );
    let cameras_selected = filters.cameras.join(",");
    let species_selected = filters.species.join(",");
    let eventStatus = status ? `&status=${status}` : "";

    let untaggedParam = "";
    if (filters.showUntagged) {
      untaggedParam = "&has_species=false";
      species_selected = "";
    }

    const [year, month, day] = result.end.split("T")[0].split("-");
    let endDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    endDate.setDate(endDate.getDate() + 1);

    const adjustedEndDate = endDate.getDate();
    const adjustedEndmonth = endDate.getMonth() + 1;
    const adjustedEndyear = endDate.getFullYear();
    const endDatefilter =
      adjustedEndyear + "-" + adjustedEndmonth + "-" + adjustedEndDate;

    axios
      .get(
        `${backend_url}/core/api/event/?date_gte=${result.start.split("T")[0]}&date_lte=${endDatefilter}&cameras=${cameras_selected}&species=${species_selected}&page=${page}&page_size=${rowsPerPage}${eventStatus}${untaggedParam}`,
        config,
      )
      .then((res) => {
        res.data["filterApplied"] = filterApplied;
        dispatch(setEvents(res.data));
      })
      .catch((err) => {
        dispatch(setSnackBar(err.message));
      })
      .finally(() => {
        dispatch(showLoadingScreen(false));
      });
  };

export const updateEventStatus = (eventIds, action) => (dispatch) => {
  dispatch(showLoadingScreen(true));
  const config = {
    headers: { Authorization: `Token ${localStorage.getItem("token")}` },
  };
  const data = {
    archived: action === "archive" ? eventIds : [],
    featured: action === "feature" ? eventIds : [],
    restore: action === "restore" ? eventIds : [],
  };

  axios
    .post(`${backend_url}/core/api/event/batch_update/`, data, config)
    .then((res) => dispatch(setSnackBar(res.data.message)))
    .catch((err) => dispatch(setSnackBar(err.message)))
    .finally(() => dispatch(showLoadingScreen(false)));
};

export const deleteEvent = (eventIds) => (dispatch) => {
  dispatch(showLoadingScreen(true));
  const config = {
    headers: { Authorization: `Token ${localStorage.getItem("token")}` },
  };
  axios
    .post(
      `${backend_url}/core/api/event/delete_events/`,
      { events: eventIds },
      config,
    )
    .then((res) => dispatch(setSnackBar(res.data.message)))
    .catch((err) => dispatch(setSnackBar(err.message)))
    .finally(() => dispatch(showLoadingScreen(false)));
};

// ✅ RESTORED: Required by EventsTable.js
export const deleteEventsWithoutTags = (eventIds) => (dispatch) => {
  dispatch(showLoadingScreen(true));
  const config = {
    headers: { Authorization: `Token ${localStorage.getItem("token")}` },
  };
  axios
    .post(
      `${backend_url}/core/api/event/delete_events_without_tags/`,
      { events: eventIds },
      config,
    )
    .then((res) => dispatch(setSnackBar(res.data.message)))
    .catch((err) => dispatch(setSnackBar(err.message)))
    .finally(() => dispatch(showLoadingScreen(false)));
};

export const annotateEvents = (eventIds, annotations) => (dispatch) => {
  dispatch(showLoadingScreen(true));
  const config = {
    headers: { Authorization: `Token ${localStorage.getItem("token")}` },
  };
  axios
    .post(
      `${backend_url}/core/api/event/annotate_species/`,
      { events: eventIds, species: annotations },
      config,
    )
    .then((res) => dispatch(setSnackBar(res.data.message)))
    .catch((err) => dispatch(setSnackBar(err.message)))
    .finally(() => dispatch(showLoadingScreen(false)));
};

export const removeAnnotations = (eventIds, annotations) => (dispatch) => {
  dispatch(showLoadingScreen(true));
  const config = {
    headers: { Authorization: `Token ${localStorage.getItem("token")}` },
  };
  axios
    .post(
      `${backend_url}/core/api/event/remove_species/`,
      { events: eventIds, species: annotations },
      config,
    )
    .then((res) => dispatch(setSnackBar(res.data.message)))
    .catch((err) => dispatch(setSnackBar(err.message)))
    .finally(() => dispatch(showLoadingScreen(false)));
};

export const { setEvents, resetEvents } = eventsSlice.actions;
export const selectEvents = (state) => state.events.events;
export default eventsSlice.reducer;
